// DS8.2
import React from 'react';
import c from 'classnames';
import s from './SpreadLayout.scss';
/** A purely layout focused component that spreads `left` and `right` props horizontally via `justify-content: space-between` */ const SpreadLayout = ({ left, right, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, left), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, right));
};
SpreadLayout.displayName = 'SpreadLayout';
export default SpreadLayout;
